import { createContext, useContext } from 'react';
import useCreateProjectForm from 'hooks/useCreateProjectForm';

/* 
  TODO:

  [] Comments
*/
const FormContext = createContext();

const useFormContext = () => {
  const context = useContext(FormContext);

  if (context === undefined) {
    throw new Error('useFormContext must be used within a FormProvider');
  }

  return context;
};

const FormProvider = ({ children, businessId }) => {
  const context = useCreateProjectForm({ businessId });

  return (
    <FormContext.Provider value={context}>{children}</FormContext.Provider>
  );
};

export { FormProvider, useFormContext };
